import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './index.css';

export class Tab extends Component {
  state = {
    active: 0,
  };

  handleNav = active => {
    this.setState({ active });
  };

  renderNav = (tab, idx) => (
    <li
      key={idx}
      className={cn('tab__nav-item', {
        'tab__nav-item--active': this.state.active === idx,
      })}
    >
      <a onClick={() => this.handleNav(idx)}>{tab.label}</a>
    </li>
  );

  renderContent = (tab, idx) => (
    <article
      key={idx}
      className={cn('tab__content-item', {
        'tab__content-item--active': this.state.active === idx,
      })}
    >
      {tab.content}
    </article>
  );

  render() {
    const { className, tabs, theme } = this.props;
    const classes = cn(
      'tab',
      className,
      theme && theme.map(css => `tab--${css}`).join(' ')
    );

    return (
      <section className={classes}>
        <ul className={'tab__nav'}>{tabs && tabs.map(this.renderNav)}</ul>
        <div className={'tab__content'}>
          {/* QUESTION: why rendering everytime switch tabs rather than show/hide in CSS and let z-index deal with the layer issue? */}
          {this.renderContent(tabs[this.state.active], this.state.active)}
        </div>
      </section>
    );
  }
}

Tab.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  theme: PropTypes.array,
};

export default Tab;



// WEBPACK FOOTER //
// ./src/common/components/Tab/index.js